import bookStackRaw from '@/assets/benchmarking-report/book-stack.svg?raw';
import characterFemaleRaw from '@/assets/benchmarking-report/character-female.svg?raw';
import characterMaleRaw from '@/assets/benchmarking-report/character-male.svg?raw';
import computerRaw from '@/assets/benchmarking-report/computer.svg?raw';
import papersRaw from '@/assets/benchmarking-report/papers.svg?raw';
import logoRaw from '@/assets/logo/logo-full.svg?raw';

export type CoverAssetName = 'characterFemale' | 'characterMale' | 'computer' | 'papers' | 'bookStack' | 'logo';

export type CoverAsset = {
  uri: string;
  naturalWidth: number;
  naturalHeight: number;
};

function svgToDataUri(svg: string): string {
  return `data:image/svg+xml;base64,${btoa(
    encodeURIComponent(svg).replace(/%([0-9A-F]{2})/g, (_, hex: string) => String.fromCharCode(parseInt(hex, 16)))
  )}`;
}

function asset(svg: string, naturalWidth: number, naturalHeight: number): CoverAsset {
  return { uri: svgToDataUri(svg), naturalWidth, naturalHeight };
}

export const coverAssets = {
  characterFemale: asset(characterFemaleRaw, 189, 471),
  characterMale: asset(characterMaleRaw, 244, 333),
  computer: asset(computerRaw, 235, 130),
  papers: asset(papersRaw, 208, 58),
  bookStack: asset(bookStackRaw, 147, 82),
  logo: asset(logoRaw, 120, 24),
} as Record<CoverAssetName, CoverAsset>;
